import axios from "axios";
import { Star } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "src/components/ui/sheet";
import { Textarea } from "src/components/ui/textarea";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { useTheme } from "next-themes";
import { SelectMembers } from "./SelectMembers";

export const ShowEditSheet = ({
  handleFetchTeams,
  users,
  showEditSheet,
  setShowEditSheet,
  editRecord,
  setEditRecord,
}) => {
  const handleReviewChange = (value) => {
    setEditRecord((prev) => ({ ...prev, review: value.toString() }));
  };

  const [loadingEdit, setLoadingEdit] = useState(false);
  const [errors, setErrors] = useState({});

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoadingEdit(true);
    setErrors({});

    try {
      await axios.put(`${BaseUrlApi}/teams/${editRecord.bid}`, {
        description: editRecord.description,
        users: editRecord.users,
        name: editRecord.name,
        review: editRecord.review,
      });
      toast("تم التعديل", { description: "تم تحديث تفاصيل المجموعة بنجاح ✏️" });

      await handleFetchTeams();
      setShowEditSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoadingEdit(false);
    }
  };

  return (
    <Sheet open={showEditSheet} onOpenChange={setShowEditSheet}>
      <SheetContent side="left" dir="rtl">
        <SheetHeader className="text-start">
          <SheetTitle>تعديل الفريق {editRecord?.name}</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          <div className="space-y-2">
            <label className="block font-medium">العنوان</label>
            <Input
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل العنوان"
              value={editRecord.name || ""}
              onChange={(e) =>
                setEditRecord({ ...editRecord, name: e.target.value })
              }
            />
            {errors?.name && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.name[0]}
              </p>
            )}
          </div>
          <div className="space-y-2 ">
            <label className="block font-medium">الوصف</label>
            <Textarea
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الوصف"
              value={editRecord.description || ""}
              onChange={(e) =>
                setEditRecord({
                  ...editRecord,
                  description: e.target.value,
                })
              }
            />
            {errors?.description && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.description[0]}
              </p>
            )}
          </div>
          <SelectMembers
            users={users}
            record={editRecord}
            setRecord={setEditRecord}
            errors={errors}
          />

          <div className="space-y-2 ">
            <label htmlFor="review" className="block font-medium">
              التقييم
            </label>
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  onClick={() => handleReviewChange(star.toString())}
                  key={star}
                  className={`w-5 h-5 cursor-pointer ${
                    editRecord.review >= star
                      ? "text-yellow-400 fill-yellow-400"
                      : "text-gray-300"
                  }`}
                />
              ))}
            </div>
            {errors?.review && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.review[0]}
              </p>
            )}
          </div>

          <div className=" text-end">
            <Button onClick={handleEdit} disabled={loadingEdit}>
              {loadingEdit ? "جاري التعديل..." : "تعديل"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
